import { useState } from 'react'
import PropTypes from 'prop-types'
import { Document, Page, pdfjs } from 'react-pdf'
import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
    '& .react-pdf__Page__canvas': {
      margin: '0 auto',
      width: 'auto !important',
      height: '150px !important',
    }
  },
}))

const PdfPreview = ({ file }) => {
  const classes = useStyles()
  const [pageNumber, setPageNumber] = useState(1)

  const onDocumentLoadSuccess = () => {
    setPageNumber(1)
  }

  return (
    <Box mb={2} className={classes.root}>
      <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
    </Box>
  )
}

PdfPreview.propTypes = {
  file: PropTypes.string.isRequired, // required since it must be a valid file path or blob
}

export default PdfPreview
